import * as Dialog from '@radix-ui/react-dialog'
import { Button } from 'src/design-system'
import React from 'react'

type PreviousRolePopupProps = {
  userName: string
  previousRoleName: string
  checkinPath?: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function PreviousRolePopup({
  userName,
  previousRoleName,
  checkinPath,
  open,
  onOpenChange,
}: PreviousRolePopupProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-popover bg-black/40" />
        <Dialog.Content className="fixed z-popover bg-white w-full max-w-[544px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-2xl shadow-[0px_6px_8px_-2px_rgba(15,20,30,0.08),0px_16px_64px_-8px_rgba(15,20,30,0.32)] p-8">
          <Dialog.Close
            className="absolute top-6 right-6 border-0 bg-transparent cursor-pointer p-0"
            aria-label="Close"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="32" height="32" rx="16" fill="#E7EAF4" />
              <path
                d="M20.7621 11.2383L11.2383 20.7621"
                stroke="#5E6580"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.7612 20.7621L11.2374 11.2383"
                stroke="#5E6580"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Dialog.Close>
          <Dialog.Title className="mb-5 text-[23px] leading-[28px] font-medium font-talent text-[#1D264A]">
            Previous role check-in
          </Dialog.Title>
          <Dialog.Description asChild>
            <div className="font-talent text-[16px] leading-[20px] text-[#5E6580]">
              <p className="mb-0 text-[16px] leading-[20px]">
                This skill rating was completed when{' '}
                <span className="font-semibold">{userName}</span> was in their
                previous role as{' '}
                <span className="font-semibold">{previousRoleName}</span>.
              </p>
              {checkinPath && (
                <>
                  <p className="mb-0 mt-5 text-[16px] leading-[20px]">
                    Click Learn more to view that check-in.
                  </p>
                  <div className="flex justify-end mt-8">
                    <Button
                      as="a"
                      href={checkinPath}
                      colourVariant="brand"
                      className="font-talent px-3.5 py-2 text-base leading-5 font-medium"
                    >
                      Learn more
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Dialog.Description>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
